import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../pages/Home";
import Migration from "../pages/Migration";
import { useState } from "react";

const Router = () => {
  const [theme, setTheme] = useState(false);
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home theme={theme} setTheme={setTheme} />} />
        <Route
          path="/migration"
          element={<Migration theme={theme} setTheme={setTheme} />}
        />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
